<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>
<div id="questionLists" class="col-md-10 mt-5">
  <div>
    <h2 class="pb-5" style="text-transform: uppercase">Executive Committee</h2>
    <div class="row pb-5">
      @for (committee of committees; track committee) {
        <div
          class="col-6 col-md-6 col-lg-4 pb-5"
          >
          <img
            src="{{ committee.img }}"
            class="img-fluid circle"
            alt="{{ committee.alt }}"
            />
            <div class="col-sm-9 mt-3">
              <p>
                <strong>{{ committee.name }}</strong>
                <br />
                <b>{{ committee.title }}</b>
                <br />
                {{ committee.description }}
                <br />
                {{ committee.city }}
              </p>
            </div>
          </div>
        }
      </div>
    </div>
    <div id="BoardofDirectors">
      <h2 class="pb-5" style="text-transform: uppercase">BOARD OF DIRECTORS</h2>
      <div class="row pb-5">
        @for (director of directors; track director) {
          <div
            class="col-6 col-md-6 col-lg-4 pb-5"
            >
            <img
              srcset="{{ director.img }} 3x"
              class="img-fluid circle"
              alt="{{ director.alt }}"
              />
              <div class="col-sm-10 mt-3">
                <p class="mt-2">
                  <strong>{{ director.name }}</strong>
                  <br />
                  <b>{{ director.title }}</b>
                  <br />
                  {{ director.description }}
                  <br />
                  {{ director.city }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
